import { Component, computed, inject, input } from '@angular/core';
import { SVG_ICONS } from "./svg-icons/svg-icons";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
  selector: 'lib-icon',
  standalone: true,
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss'
})
export class IconComponent {
  private sanitizer = inject(DomSanitizer);

  iconName = input<string>('');
  icon = computed<SafeHtml>(() => {
    const svg = SVG_ICONS[this.iconName()] ?? '';
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  });
}
